"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONBOARDING_SERVICE_NAME = void 0;
exports.ONBOARDING_SERVICE_NAME = "lv-onboarding-srv";
//# sourceMappingURL=base.js.map